<template>
  <div id="app">
    <a @click="Download()" class="toplink">
      <img src="./assets/open_app_top_kd.png">
    </a>
    <router-view/>
    <div id="cover_downL" class="cover_downL" v-if="showdownload" @click="showdownload=false">
      <div style="text-align: right;margin-right: 0.6rem;margin-top: 1.75rem;">
        <img style="width: 30%;" src="http://img2.yitoutiao.net/assets/img/guide.png">
      </div>
      <div class="covr_tip">
        <div  style=" font-size: 16px; line-height: 2">
          <h3 style="text-align: center;">下载看度时政APP</h3>
          <p>1.点击右上角</p>
          <p>2.列表中选择“浏览器中打开”</p>
          <p>3.在浏览器中点击进行下载</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import utils from './utils'
export default {
  name:'app',
  data(){
    return{
      showdownload:false
    }
  },


  methods:{

    Download(){
      console.log(this.$route,this.$route.params)

      if(utils.is_weixin()){
        this.showdownload = true
        return
      }

      let url ='http://img2.yitoutiao.net/app/download.html';
      switch(this.$route.name){
        case "NewsContent":
          let id = this.$route.params.id;
          if(id){
            url = 'shenniao://app?code={"module":"zixun","page":"art_info","id":'+id+'}';
          }
          break;

      }









      setTimeout(()=>{
        location.href = 'http://img2.yitoutiao.net/app/download.html';
      },500)
      location.href = url;
    },
  }
}
</script>
<style>
  #app{ display: flex; position: fixed; width: 100%; height:100%; left: 0; top: 0; right: 0;bottom:0; flex-direction: column;
  }
.toplink{ width: 100%; }
.toplink img{ width: 100%; display: block; max-width: 640px;margin: auto}


  .cover_downL{position: absolute;left: 0;top: 0;right: 0;bottom: 0;background: rgba(0,0,0,.65); z-index: 1000}
  .covr_tip>div{
    background: #fff;border-radius: 0.325rem;width:80%;padding:0.6rem;margin: 0.6rem auto;box-shadow: 0 0 0.4rem 1px rgba(0,0,0,.4);text-align: left;padding-left: 2rem;
  }


</style>
